/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { BombiixSortButton } from '../../../Components/BombiixSortButton';
import SuppliersComponentCard from '../../../Components/Card/SuppliersComponentCard/SuppliersComponenetCard';
import * as action from '../store/Supplier.action';
import { Page_Size } from '../../../Components/helper';
import Loader from '../../../Components/Utility/Loader/Loader';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import SupplierTabNav from '../SupplierTabNav';
import { Floaty, FloatyButton, FloatyGroup } from '../../../Components/Floaty';
import { AddIcon, DeleteIcon } from '../../../bombiix-icon';
import { NewSearch } from '../../../Components/PIM/common/NewSearch';
import { NewBackButton } from '../../../Components/PIM/common/NewBackButton';
import { NewCheckbox } from '../../../Components/PIM/common/NewCheckbox';
import { BombiixModal } from '../../../Components/BombiixModal';

function SuppliersComponent({ match, supplierId }) {
  const { t } = useTranslation('modules/partner-overview');
  const { t: tCommon } = useTranslation('common');
  const dispatch = useDispatch();
  const history = useHistory();
  const reducer = useSelector((reducer_state) => reducer_state);
  const { SuppliersDetails } = reducer;
  const [selectedTier, setSelectedTier] = useState('Tier1');

  useEffect(() => {
    const tier = localStorage.getItem('SupplierSelectedTier') || 'Tier1';
    setSelectedTier(tier);
  }, []);

  const isProductionLocationTier = selectedTier !== 'Tier1';

  const { componetSuppliers, totalRecords_ComponetSuppliers } = SuppliersDetails;
  const { search, pathname } = useLocation();
  const queryParams = new URLSearchParams(search);
  const querySupplierId = queryParams?.get('supplierId');
  let nonIntegratedSupp = false;
  if (querySupplierId && pathname?.includes('/supplier-account-details')) {
    nonIntegratedSupp = true;
  }

  const supplierIds = match?.params?.supplierId || supplierId;

  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedFactoryIds, setSelectedFactoryIds] = useState([]);
  const [showDeleteSupplierComponent, setShowDeleteSupplierComponent] = useState(false);
  const [state, setState] = useState({
    pageIndex: 1,
    pageSize: Page_Size,
    componentSuppliersAll: [],
    hasMore: true,
    loading: true,
    totalRecords: null,
    searchLoaded: false,
    searchText: '',
    sortBy: null,
  });
  const sortByOptions = [
    {
      value: 'Asc',
      propertyName: 'factoryName',
      label: t('SUPLIER_COMPONENTS.FACTORY-ASCENDING'),
    },
    {
      value: 'Desc',
      propertyName: 'factoryName',
      label: t('SUPLIER_COMPONENTS.FACTORY_DECENDING'),
    },
  ];
  const ProductTestingData = useSelector((redState) => redState);
  const { Users } = ProductTestingData;
  const { logInRights } = Users;
  const [userRights, setUserRights] = useState({});

  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, []);

  useEffect(() => {
    if (supplierId) {
      dispatch(action.fetchSingleSupplierDetailsAction(supplierId));
    }
  }, [supplierId, dispatch]);

  const { CheckActionPermission } = useComponent();

  const CostingAddEditAccess = CheckActionPermission(userRights, 'supplierOverview', 'all', 'addEdit');
  const CostingDeleteAccess = CheckActionPermission(userRights, 'supplierOverview', 'all', 'delete');

  const editSupplierComponenet = async (id) => {
    if (!componetSuppliers?.length) {
      return;
    }

    const lastSupplierIndex = componetSuppliers.length - 1;
    const lastSupplierId = componetSuppliers[lastSupplierIndex]?._id;
    const targetId = id || lastSupplierId;

    if (!targetId) {
      return;
    }

    history.push(`/factories/edit/${targetId}?supplierId=${supplierIds}`);
  };
  const deleteSupplierComponenet = async () => {
    setState((subState) => ({
      ...subState,
      loading: true,
    }));
    await dispatch(
      action.deleteComponentSupplier(
        {
          factoryIds: selectedIndex ? [selectedIndex] : selectedFactoryIds,
          supplierId: supplierIds,
          section: 'supplierOverview',
          action: 'delete',
        },
        t,
      ),
    );
    setShowDeleteSupplierComponent(!showDeleteSupplierComponent);
    setSelectedFactoryIds([]);
    setSelectedIndex(null);
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      componentSuppliersAll: [],
      totalRecords: state.totalRecords,
      searchText: state.searchText,
      sortBy: state.sortBy,
      supplierId: supplierIds,
    };
    await getData(params);
    setState((ste) => ({
      ...ste,
      loading: false,
    }));
  };
  const deleteComponentForSupplier = (i) => {
    setShowDeleteSupplierComponent(!showDeleteSupplierComponent);
    setSelectedIndex(i);
  };

  const visibleFactoryIds = (state.componentSuppliersAll ?? []).map((entry) => entry?.factoryId).filter(Boolean);
  const allFactoriesSelected = visibleFactoryIds.length > 0 && visibleFactoryIds.every((id) => selectedFactoryIds.includes(id));

  /**
   * Ticks every factory on the page, or clears the selection when all are
   * already ticked.
   * @returns {void}
   */
  const handleSelectAllFactories = () => {
    setSelectedFactoryIds(allFactoriesSelected ? [] : visibleFactoryIds);
  };

  /**
   * Arms the same confirm popup for the checkbox selection rather than one
   * card. `selectedIndex` is cleared so the delete reads the selection — the
   * API already takes `factoryIds` as an array, so one call covers both.
   * @returns {void}
   */
  const deleteSelectedFactories = () => {
    setSelectedIndex(null);
    setShowDeleteSupplierComponent(true);
  };

  /**
   * Adds or removes one factory from the selection.
   * @param {string} factoryId - The factory's id.
   * @returns {void}
   */
  const toggleFactorySelection = (factoryId) => {
    setSelectedFactoryIds((previous) => (previous.includes(factoryId) ? previous.filter((id) => id !== factoryId) : [...previous, factoryId]));
  };

  const initialExicution = async () => {
    setState((iniState) => ({
      ...iniState,
      loading: true,
    }));
    const params = {
      pageIndex: 1,
      pageSize: Page_Size,
      componentSuppliersAll: [],
      supplierId: supplierIds,
    };
    await dispatch(action.fetchSupplierComponents(params));
    setState((sta) => ({
      ...sta,
      loading: false,
    }));
  };

  const getData = async (data) => {
    if (data.totalRecords !== null && data.componentSuppliersAll.length >= data.totalRecords) {
      setState((st) => ({
        ...st,
        hasMore: false,
      }));
      return;
    }

    setState((stat) => ({
      ...stat,
      loading: true,
    }));

    const params = {
      pageIndex: data?.pageIndex,
      pageSize: data?.pageSize,
      supplierId: data?.supplierId,
    };

    if (data.searchText) {
      params.searchText = data?.searchText;
    }

    if (data.sortBy) {
      params.sortOrder = data?.sortBy?.value;
      params.sortPropertyName = data?.sortBy?.propertyName;
    }
    await dispatch(action.fetchSupplierComponents(params));

    const resDoc = [state.componentSuppliersAll];

    setState((pState) => ({
      ...pState,
      componentSuppliersAll: resDoc ? [...resDoc, ...componetSuppliers] : [],
      pageIndex: data.pageIndex + 1,
      loading: false,
      totalRecords: resDoc ? totalRecords_ComponetSuppliers : 0,
    }));
  };

  const handleSort = async (e) => {
    setState((iState) => ({
      ...iState,
      sortBy: e,
      loading: true,
      pageIndex: 1,
      componentSuppliersAll: [],
      totalRecords: null,
      hasMore: true,
    }));
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      searchText: state.searchText,
      sortBy: e,
      componentSuppliersAll: [],
      totalRecords: null,
      supplierId: supplierIds,
    };
    await getData(params);
  };

  const handleSearch = (e) => {
    setState((previousState) => ({
      ...previousState,
      searchText: e?.target?.value,
      searchLoaded: true,
    }));
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        setState((initial) => ({
          ...initial,
          loading: true,
          pageIndex: 1,
          componentSuppliersAll: [],
          totalRecords: null,
          hasMore: true,
          pageSize: state.pageSize,
          sortBy: state.sortBy,
        }));
        const params = {
          searchText: state.searchText,
          componentSuppliersAll: [],
          pageIndex: 1,
          totalRecords: null,
          sortBy: state.sortBy,
          pageSize: state.pageSize,
          supplierId: supplierIds,
        };
        await getData(params);
        setState((init) => ({
          ...init,
          loading: false,
        }));
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [state?.searchText]);

  useEffect(() => {
    initialExicution();
  }, []);

  useEffect(() => {
    const clearCalled = async () => {
      await dispatch(action.clearFactory([]));
    };
    clearCalled();
  }, []);

  useEffect(() => {
    setState((initState) => ({
      ...initState,
      componentSuppliersAll: componetSuppliers,
      totalRecords: totalRecords_ComponetSuppliers,
    }));
  }, [componetSuppliers, totalRecords_ComponetSuppliers]);

  const handleNextPagesInScroll = async () => {
    const params = {
      pageIndex: state.pageIndex,
      pageSize: state.pageSize,
      searchText: state.searchText,
      sortBy: state.sortBy,
      supplierId: supplierIds,
      componentSuppliersAll: state.componentSuppliersAll,
      totalRecords: state.totalRecords,
      componentData: componetSuppliers.length,
    };
    await getData(params);
  };

  /**
   * Mirrors a factory's new active state into the listed cards without refetching.
   * @param {string} factoryId - Factory whose state changed.
   * @param {boolean} isActive - The stored state.
   */
  const handleFactoryActiveStateChange = (factoryId, isActive) => {
    setFactoryActiveStates((prevStates) => ({ ...prevStates, [factoryId]: isActive }));
  };

  const [factoryActiveStates, setFactoryActiveStates] = useState({});
  const visibleFactoryIdsKey = visibleFactoryIds.join(',');

  useEffect(() => {
    let cancelled = false;
    if (!supplierIds || !visibleFactoryIdsKey) return undefined;
    dispatch(action.fetchFactoryActiveStatesAction(supplierIds)).then((states) => {
      if (!cancelled && states) setFactoryActiveStates(states);
    });
    return () => {
      cancelled = true;
    };
  }, [dispatch, supplierIds, visibleFactoryIdsKey]);

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{isProductionLocationTier ? t('NEW_PARTNER_OVERVIEW.PRODUCTION_lOCATION') : t('SUPLIER_COMPONENTS.FACTORIES')}</h4>
        </div>
        <div className="action-icons-container">
          <NewSearch
            className="bombiix-search"
            value={state?.searchText ?? ''}
            onChange={(value) => handleSearch({ target: { value } })}
            placeholder={isProductionLocationTier ? t('SUPPLIER_OVERVIEW.SEARCH_PRODUCTION_LOCATION') : t('SUPPLIER_OVERVIEW.SEARCH_FACTORY')}
            width={200}
          />
          {/*
            The sort control is a direct child of `.action-icons-container`, a
            flex row with `gap: 8px` and `align-items: center`. It carries no
            spacing utility — an `mr-2` wrapper stacked on the row's own gap —
            and no wrapper element: a block-level `<div>` around it became the
            flex item, so the row centred the wrapper while the button sat 3px
            high inside its line box.

            Its options carry the direction in `value`, which the control names
            `sortOrder`, so it is mapped in for display and the original option
            object is handed back — the request payload is unchanged.
          */}
          <BombiixSortButton
            options={sortByOptions.map((option) => ({ ...option, sortOrder: option.value }))}
            value={state.sortBy ? { ...state.sortBy, sortOrder: state.sortBy.value } : null}
            onChange={(selected) =>
              handleSort(
                selected ? sortByOptions.find((option) => option.propertyName === selected.propertyName && option.value === selected.value) ?? null : null,
              )
            }
            sortByLabel={tCommon('BTN_SORT.SORT_BY')}
            ariaLabel={tCommon('BTN_SORT.SORT')}
          />
          {!nonIntegratedSupp && <NewBackButton onBack={() => history.push('/suppliers')} />}
        </div>
      </div>
      <Floaty position="fixed">
        {CostingAddEditAccess && (
          <FloatyButton icon={AddIcon} label={t('ADD_EDIT_COMPONENET.ADD_FACTORY')} onClick={() => history.push(`/factories/add?supplierId=${supplierIds}`)} />
        )}
        {/*
         * Delete sits in its own recessed well, greyed until something is ticked
         * (Figma node 12385:169401).
         */}
        {CostingDeleteAccess && (
          <FloatyGroup disabled={selectedFactoryIds.length === 0}>
            <FloatyButton icon={DeleteIcon} variant="red" label={t('PRODUCT_LISTING_CARD.DELETE')} onClick={deleteSelectedFactories} />
          </FloatyGroup>
        )}
      </Floaty>

      <SupplierTabNav
        trailingContent={
          <NewCheckbox
            size="sm"
            id="factories-select-all"
            checked={allFactoriesSelected}
            onChange={handleSelectAllFactories}
            label={tCommon('COMMON_LABEL.SELECT_ALL')}
          />
        }
      />

      <div>
        <div>
          <InfiniteScroll
            dataLength={state.componentSuppliersAll.length}
            next={() => handleNextPagesInScroll()}
            hasMore={state.hasMore}
            loader={state.loading && <Loader />}
          >
            <div className="container-fluid py-4">
              <div className="partner-card-grid">
                {!state.loading && state.componentSuppliersAll && state.componentSuppliersAll.length
                  ? state.componentSuppliersAll.map((ele, i) => (
                      <React.Fragment key={i}>
                        <SuppliersComponentCard
                          edit={editSupplierComponenet}
                          element={ele}
                          isSelected={selectedFactoryIds.includes(ele?.factoryId)}
                          onSelect={toggleFactorySelection}
                          onDelete={deleteComponentForSupplier}
                          loader={state.loading}
                          CostingAddEditAccess={CostingAddEditAccess}
                          CostingDeleteAccess={CostingDeleteAccess}
                          supplierId={supplierIds}
                          isActive={factoryActiveStates[ele?.factoryId] !== false}
                          onActiveStateChange={handleFactoryActiveStateChange}
                        />
                      </React.Fragment>
                    ))
                  : null}
                {!state.loading && state.componentSuppliersAll && state.componentSuppliersAll.length === 0 && (
                  <div className="partner-empty-state">
                    <h6>{t('SUPLIER_COMPONENTS.NO_RECORDS_FOUND')}</h6>
                  </div>
                )}
              </div>
            </div>
          </InfiniteScroll>

          <BombiixModal
            show={showDeleteSupplierComponent}
            size="sm"
            title={isProductionLocationTier ? t('SUPLIER_COMPONENTS.DELETE_SUPPLIER_LOCATION') : t('SUPLIER_COMPONENTS.DELETE_SUPPLIER_FACTORY')}
            onClose={() => setShowDeleteSupplierComponent(!showDeleteSupplierComponent)}
            onSave={deleteSupplierComponenet}
            saveLabel={tCommon('COMMON_LABEL.DELETE')}
            saveVariant="red"
            saveLoading={state.loading}
          >
            <div className="bombiix-modal__confirm-body">
              <p className="mb-0 text-center">
                {isProductionLocationTier ? t('SUPLIER_COMPONENTS.ARE_YOU_SURE') : t('SUPLIER_COMPONENTS.ARE_YOU_SURE_DELETE')}
              </p>
            </div>
          </BombiixModal>
        </div>
      </div>
    </>
  );
}

export default SuppliersComponent;
